import { z } from 'zod';

export const contractTypes = ['HardwareLease', 'Infrastructure', 'Software', 'HardwareSupply', 'Telco', 'Other'] as const;

export const contractSchema = z.object({
  ContractName: z.string().trim().min(1, 'Contract name is required'),
  ContractNumber: z.string().trim().optional(),
  Vendor: z.string().trim().min(1, 'Select a vendor'),
  SupplierId: z.number().int().positive().nullable().optional(),
  ContractType: z.enum(contractTypes),
  StartDate: z.string().trim().optional(),
  EndDate: z.string().trim().optional(),
  NoticeDate: z.string().trim().optional(),
  MonthlyCost: z.number().nonnegative().nullable().optional(),
  AnnualCost: z.number().nonnegative().nullable().optional(),
  TotalValue: z.number().nonnegative().nullable().optional(),
  AutoRenews: z.boolean(),
  Notes: z.string().trim().optional(),
});

export type ContractFormData = z.infer<typeof contractSchema>;
